import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WompiReportsService, ReportConciliationLogDTO } from '../../../services/wompi-reports.service';
import { ToastService } from '../../../services/toast.service';
import { LoadingService } from '../../../services/loading.service';

@Component({
  selector: 'app-conciliation-logs',
  templateUrl: './conciliation-logs.component.html',
  styleUrls: ['./conciliation-logs.component.scss']
})
export class ConciliationLogsComponent implements OnInit {
  logs: ReportConciliationLogDTO[] = [];
  
  // Filters
  dateFrom: string = '';
  dateTo: string = '';
  
  // UI State
  loading: boolean = false;

  constructor(
    private router: Router,
    private wompiReportsService: WompiReportsService,
    private toastService: ToastService,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    // Set default date range to last 30 days
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);
    
    this.dateTo = this.formatDateForInput(today);
    this.dateFrom = this.formatDateForInput(thirtyDaysAgo);
    
    this.loadLogs();
  }

  loadLogs(): void {
    this.loading = true;
    this.loadingService.show();

    const from = this.dateFrom ? new Date(this.dateFrom) : undefined;
    const to = this.dateTo ? new Date(this.dateTo) : undefined;

    this.wompiReportsService.getConciliationLogs(from, to).subscribe({
      next: (logs) => {
        this.logs = logs;
        this.loading = false;
        this.loadingService.hide();
      },
      error: (error) => {
        console.error('Error loading logs:', error);
        this.toastService.showToast('error', 'Error al cargar los logs de conciliación');
        this.loading = false;
        this.loadingService.hide();
      }
    });
  }

  applyFilters(): void {
    this.loadLogs();
  }

  clearFilters(): void {
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);
    
    this.dateTo = this.formatDateForInput(today);
    this.dateFrom = this.formatDateForInput(thirtyDaysAgo);
    this.loadLogs();
  }

  viewLogDetail(log: ReportConciliationLogDTO): void {
    this.router.navigate(['/dashboard/config/conciliation-logs', log.id]);
  }

  getStatusBadgeClasses(status: number): string {
    switch (status) {
      case 0: // Pending
        return 'bg-gray-100 text-gray-800';
      case 1: // Running
        return 'bg-blue-100 text-blue-800';
      case 2: // Completed
        return 'bg-green-100 text-green-800';
      case 3: // CompletedWithErrors
        return 'bg-amber-100 text-amber-800';
      case 4: // Failed
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  }

  formatDate(dateString: string | undefined): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CO', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatDuration(ms: number): string {
    if (ms < 1000) return `${ms}ms`;
    const seconds = Math.floor(ms / 1000);
    if (seconds < 60) return `${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
  }

  private formatDateForInput(date: Date): string {
    return date.toISOString().split('T')[0];
  }
}

